// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:601px){.add-store-modal__container[data-v-21bd44e9]{padding:30px 40px}}.add-store-modal__body[data-v-21bd44e9]{margin-top:30px}.v-list[data-v-21bd44e9] .v-list-item{max-height:50px!important}", ""]);
// Exports
module.exports = exports;
